import { render, staticRenderFns } from "./payWxAlert.vue?vue&type=template&id=01c5d4e8&scoped=true"
import script from "./payWxAlert.vue?vue&type=script&lang=js"
export * from "./payWxAlert.vue?vue&type=script&lang=js"
import style0 from "./payWxAlert.vue?vue&type=style&index=0&id=01c5d4e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c5d4e8",
  null
  
)

export default component.exports